import { ref, computed } from 'vue';

const isSelectionMode = ref(false);
const selectedMessages = ref([]);

export function useMessageSelection() {
  const selectedCount = computed(() => selectedMessages.value.length);
  const hasSelection = computed(() => selectedMessages.value.length > 0);

  function enterSelectionMode() {
    isSelectionMode.value = true;
  }

  function exitSelectionMode() {
    isSelectionMode.value = false;
    selectedMessages.value = [];
  }

  function toggleMessageSelection(message) {
    const index = selectedMessages.value.findIndex(m => m.id === message.id);
    if (index === -1) {
      selectedMessages.value = [...selectedMessages.value, message];
    } else {
      selectedMessages.value = selectedMessages.value.filter(
        m => m.id !== message.id
      );
    }
  }

  function isMessageSelected(messageId) {
    return selectedMessages.value.some(m => m.id === messageId);
  }

  function clearSelection() {
    selectedMessages.value = [];
  }

  return {
    isSelectionMode,
    selectedMessages,
    selectedCount,
    hasSelection,
    enterSelectionMode,
    exitSelectionMode,
    toggleMessageSelection,
    isMessageSelected,
    clearSelection,
  };
}
